import React, { useState } from "react";
import "./CustomSelect.css";

interface CustomSelectProps {
  options: string[];
  defaultValue?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  defaultValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(defaultValue || options[0]);

  const handleSelect = (option: string) => {
    setSelected(option);
    setIsOpen(false);
  };

  return (
    <div className="custom-select">
      <div
        className="custom-select__selected"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected}
        <span className={`arrow ${isOpen ? "open" : ""}`}>▾</span>
      </div>
      {isOpen && (
        <ul className="custom-select__options">
          {options.map((option, index) => (
            <li
              key={index}
              className={`custom-select__option ${
                option === selected ? "selected" : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
